/*
* Copyright Gregory Coburn 2020-2026, All Rights Reserved, See license for further details
*/
import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { AbstractHttpService } from '@src/app/shared/abstract-http.service';
import { MessageService } from '@src/app/shared/message.service';
import { Txn } from '@src/app/model/txn';

@Injectable({
    providedIn: 'root'
})
export class DebtorsListService extends AbstractHttpService {
    protected http = inject(HttpClient);
    protected messageService = inject(MessageService);


    protected get baseUrl(): string {
        return this.getAjaxPath('txn/debtorsList');
    }
    protected cache: Txn[];
    protected typeString = 'DebtorsList';

}
